var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShapesForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1953 17.1387C9.93491 16.8784 9.93491 16.4563 10.1953 16.1959L14.3905 12.0007L10.1953 7.80539C9.93491 7.54504 9.93491 7.12293 10.1953 6.86258C10.4556 6.60223 10.8777 6.60223 11.1381 6.86258L15.8047 11.5292C16.0651 11.7896 16.0651 12.2117 15.8047 12.4721L11.1381 17.1387C10.8777 17.3991 10.4556 17.3991 10.1953 17.1387Z",
    fill: "#1A181E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapesForward);
export default __webpack_public_path__ + "static/media/shapes-forward.5dd7a5f7c8bf3be841f1a9e6b58c75b7.svg";
export { ForwardRef as ReactComponent };